import React from "react";

const IMG = `${import.meta.env.BASE_URL}img/cards`;

const QUESTIONS = ["[Q1] Red-Black", "[Q2] Odd-Even", "[Q3] 7 Up-7 Down", "[Q4] 3 Card Judgement", "[Q5] Suits"];

/**
 * Reference result body for K.B.C (kbc): the round's cards (card "1" skipped) + the five answers from rdesc
 *   .row.row5.worli-result > .col-12.col-lg-6 (cards) + .col-12.col-lg-6 (.casino-result-desc)
 */
export default function KbcResultBody({ t1 }) {
  const cards = String(t1?.card || "").split(",").map((c) => c.trim()).filter(Boolean);
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];

  return (
    <div className="row row5 worli-result">
      {cards.length > 0 && (
        <div className="col-12 col-lg-6">
          <div className="casino-result-content">
            <div className="casino-result-content-item text-center w-100">
              <div className="casino-result-cards">
                {cards.map((c, i) =>
                  c !== "1" ? (
                    <div className="casino-result-cards-item" key={i}>
                      <img src={`${IMG}/${c}.png`} alt="" />
                    </div>
                  ) : null
                )}
              </div>
            </div>
          </div>
        </div>
      )}{" "}
      <div className="col-12 col-lg-6">
        {desc.length > 0 && (
          <div className="casino-result-desc">
            {QUESTIONS.map((label, i) => (
              <React.Fragment key={label}>
                {i > 0 && " "}
                <div className="casino-result-desc-item">
                  <div>{label}</div> <div>{desc[i]}</div>
                </div>
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
